import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'profile.copy-content-block.copied.aria-label': {
    id: 'profile.copy-content-block.copied.aria-label',
    defaultMessage: 'Content copied to clipboard',
    description: 'The aria-label for the button when the content has been copied to clipboard.',
  },
  'profile.copy-content-block.copy.aria-label': {
    id: 'profile.copy-content-block.copy.aria-label',
    defaultMessage: 'Copy content to clipboard',
    description: 'The aria-label for the button to copy content to clipboard.',
  },
  'profile.copy-content-block.copied': {
    id: 'profile.copy-content-block.copied',
    defaultMessage: 'Copied',
    description: 'The message displayed when the content has been copied to clipboard.',
  },
  'profile.copy-content-block.copy': {
    id: 'profile.copy-content-block.copy',
    defaultMessage: 'Copy',
    description: 'The message displayed when the content is copied to clipboard.',
  },
});

export default messages;
